<template>
  <div class="heroes-pick-result">
    Выбранный герой:
    <Hero v-if="hero" class="heroes-pick-result__hero" :hero="hero" />
  </div>
</template>

<script>
import Hero from "./Hero";
import { mapState } from "vuex";

export default {
  name: "HeroesPickResult",

  components: {
    Hero
  },

  props: {
    pick: [Number, String]
  },

  computed: {
    ...mapState("dictionaries", {
      heroes: ({ dictionaries }) => dictionaries.heroes
    }),

    hero() {
      return this.heroes && this.heroes.find(hero => hero.id === this.pick);
    }
  }
};
</script>

<style lang="scss">
.heroes-pick-result {
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 17px;
  margin: 30px auto 40px;

  &__hero {
    margin-left: 10px;
    width: 66px;
    height: 38px;
  }
}
</style>
